export type LoginActionState = {
    effect: null | VoidFunction;
};

export const initialLoginActionState: LoginActionState = {
    effect: null,
};
